import dayjs from 'dayjs'
import domain from '@/config/domain'
import get from 'lodash/get'
import { ref, Ref } from '@vue/composition-api'
import debounce from 'lodash/debounce'
import Vue from 'vue'

export const inputNumberLimitReg = /^\d+$/
export const inputLimitRegExp = /^([1-9][0-9]{0,5}|[0]{1})(\.\d{0,2})?$/
export const inputSpaceLimitReg = /^[^ ]+$/
export const inputCodeLimitReg = /^\d{0,4}$/
export const inputSpaceLimit = inputLimit(inputSpaceLimitReg)
export function inputLimit(reg: RegExp = inputLimitRegExp) {
    return function(that: { [propName: string]: any }, key: string | number) {
        // debugger
        const fn = Object.prototype.toString.call(that[key]) === "[object Number]" ? Number : String
        let value = that[key].toString()
        do {
            if (!reg.test(value)) {
                if (value.length > 0) {
                    value = value.substr(0, value.length - 1)
                    that[key] = fn(value)
                } else {
                    return
                }
            }
        } while (!reg.test(value))
    }
}

export function isLt500() {
    const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    return w <= 500
}

export function isPC() {
    if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        return false
    } else {
        return true
    }
}

export function getQueryString(href: string, key: string) {
    const reg = new RegExp('[?&]' + key + '=([^&]*)', 'g')
    let match = (href || window.location.search).match(reg)
    if (!match) { return }
    if (match.length === 1) { return decodeURIComponent(match[0].replace(reg, '$1')) }
    match = match.map(function(item) {
        return decodeURIComponent(item.replace(reg, '$1'))
    })
    return match
}

export function setObjectItemToFixed(obj, options?: {
    fixed?: number,
    ignore?: string[]
}) {
    options = Object.assign({
        fixed: 2,
        ignore: []
    }, options)
    if (Object.prototype.toString.call(obj) === '[object Object]') {
        for (const i in obj) {
            if (!options.ignore!.includes(i)) {
                obj[i] = setObjectItemToFixed(obj[i], options)
            }
        }
    } else if (Object.prototype.toString.call(obj) === "[object Array]") {
        obj = obj.map(value => {
            value = setObjectItemToFixed(value, options)
            return value
        })
    } else {
        if (/^-?\d+\.\d+$/.test(obj)) {
            return (+obj).toFixed(options.fixed)
        } else {
            return obj
        }
    }

    return obj
}

export function getOneMonthValue(isFormat = false) {
    const today = dayjs()
    const todayBeforeOneMonth = dayjs().subtract(1, 'month')
    if (isFormat) {
        return [todayBeforeOneMonth.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]
    } else {
        return [todayBeforeOneMonth.toDate(), today.toDate()]
    }
}

export const cookieHandler = {
    getAllCookie(): object | undefined {
        const cookieArr = document.cookie.split('; ')
        if (cookieArr.length === 0) {
            return
        }
        return cookieArr.reduce((prev, next) => {
            const arr = next.split('=')
            prev[arr[0]] = arr[1]
            return prev
        }, {})
    },

    getCookieByName(name: string): string {
        const allCookie = this.getAllCookie()
        if (allCookie == null) {
            return ''
        }
        return allCookie[name]
    },

    setCookie(k: string, v: string, domainStr: string = window.location.host, maxAge: string | number = 3600 * 24, path: string = '/'): void {
        document.cookie = `${k}=${v}; domain=${domainStr}; max-age=${maxAge}; path=${path}`
    },

    deleteCookie(k: string, domainStr: string): void {
        this.setCookie(k, '', domainStr, -1)
    }
}

export function clearSenguoCookie(callback: () => any = function() { }): void {
    const allCookie = cookieHandler.getAllCookie()
    if (!allCookie) {
        return
    }
    Object.keys(allCookie).forEach(k => {
        cookieHandler.deleteCookie(k, domain.topLevel)
    })
    callback()
}

export function debounceSubmit(submitFn: () => any | Promise<any>) {
    let lock = false
    return function() {
        if (lock) {
            return
        }
        lock = true
        if (Object.prototype.toString.call(submitFn) === '[object Promise]') {
            return submitFn().then(() => {
                setTimeout(() => {
                    lock = false
                }, 600)
            })
        } else {
            setTimeout(() => {
                lock = false
            }, 600)
            return submitFn()
        }
    }
}

type timeTypeInterface = "millisecond" | "second" | "minute" | "hour" | "day" | "month" | "year" | "date" | "d" | "M" | "y" | "h" | "m" | "s" | "ms" | "week" | "w" | "quarter" | "Q" | undefined
// 获取日期间的差值，返回的是天数
export function getDayBeweenDate(d1: string, d2: string, type: timeTypeInterface = 'day', flag = false) {
    return dayjs(d1).diff(dayjs(d2), type, flag)
}

export function fixNum(num: string | number, fixed = 2) {
    const n = +num
    return (n).toFixed(fixed)
}

export function fixNumPro(num: string | number, fixed = 2) {
    return Math.round((Math.round(+num * Math.pow(10, fixed) * 10) / 10)) / Math.pow(10, fixed)

    // if (typeof num !== 'string' && typeof num !== 'number') {
    //     return 0
    // }
    // const [first, second] = num.toString().split('.')
    // if (second == null) {
    //     return +first
    // }
    // const result = `${first}.${second.substr(0, fixed)}`
    // return +result
}

// withQMark 是否携带? 如?a=1
export function queryString(obj: { [prop: string]: any }, withQMark = false) {
    const str = Object.entries(obj).reduce((next: any, prev) => {
        if (prev[1] != null) {
            next.push(`${prev[0]}=${prev[1]}`)
        }
        return next
    }, [] as any[]).join('&')
    return withQMark ? `?${str}` : str
}

// 获取文字长度
export function getLen(str: string, unit: number = 14) {
    const reg = /[\u4e00-\u9fa5]/
    // tslint:disable-next-line:no-shadowed-variable
    const len = str.length
    let n = 0
    for (let i = 0; i < len; i++) {
        if (str[i] === '.') {
            continue
        }
        if (reg.test(str[i])) {
            // 双字节
            n += unit
        } else {
            // 单字节
            n += unit / 2
        }
    }

    return n
}

export function getSum(...args): number {
    return fixNumPro(args.map(item => (+item).toFixed(2))
        .reduce((next, prev) => {
            next += +prev * 1000
            return next
        }, 0) / 1000)
}

export function getSumByKey(arr: any[], key?: string) {
    if (arr.length === 0) {
        return '0.00'
    }

    return fixNumPro(arr.reduce((next, prev) => {
        if (key == null) {
            next += +prev
        } else {
            next += +get(prev, key)
        }

        return next
    }, 0))
}

export function storageUtil(type: 'local' | 'session') {
    const storage: Storage = window[type + 'Storage']

    function isInStorage(key: string) {
        return storage.getItem(key) != null
    }

    function getDataFromStorage(key: string) {
        if (isInStorage(key)) {
            return JSON.parse(storage.getItem(key) as string)
        }
    }

    function setDataFromStorage(key: string, value: any) {
        storage.setItem(key, JSON.stringify(value))
    }

    function toggleDataFromStorage(key: string, value: any) {
        if (isInStorage(key)) {
            return getDataFromStorage(key)
        } else {
            setDataFromStorage(key, value)

            return value
        }
    }

    function clearDataFromStorage() {
        storage.clear()
    }

    function deleteDataFromStorage(key: string) {
        storage.removeItem(key)
    }

    return {
        isInStorage,
        getDataFromStorage,
        setDataFromStorage,
        toggleDataFromStorage,
        clearDataFromStorage,
        deleteDataFromStorage
    }
}

interface AnyObj {
    [prop: string]: string
}

interface BoolObj {
    [prop: string]: boolean
}

/**
 * -1 表示正常
 *  1 表示比上一个大或者小
 *  2 表示比下一个大或者小
 */
export function inputValider(
    levels: Ref<any[]> | any[],
    iptTypeObj: AnyObj,
    limitReg: RegExp,
    isGTObj?: BoolObj
) {
    const isIpt = ref(false)
    const zeroReg = /^0+\.?0*$/
    const iptTypeArr = Object.keys(iptTypeObj)
    const inputLimiter = inputLimit(limitReg)
    const debounceIptHandler = debounce(iptHandler, 500)
    const oIsGTObj = isGTObj || {}
    if (isGTObj == null) {
        iptTypeArr.forEach(k => {
            oIsGTObj[k] = true
        })
    }

    function getLevels() {
        if ((levels as any).value) {
            return (levels as any).value
        } else {
            return levels
        }
    }

    function handleIpt(item, type, index: number) {
        !isIpt.value && (isIpt.value = true)
        inputLimiter(item, type)
        debounceIptHandler(item, type, index)
    }

    function delConfirm(index: number) {
        const curLevels = getLevels()
        const lastL = curLevels[index - 1]
        const nextL = curLevels[index + 1]
        curLevels.splice(index, 1)
        iptTypeArr.forEach(iptType => {
            if (lastL != null) {
                findError(lastL, iptType, index - 1)
            } else {
                findError(nextL, iptType, index)
            }
        })
    }

    function iptHandler(item, type, index: number) {
        findError(item, type, index)
        isIpt.value && (isIpt.value = false)
    }

    function findError(item, type, index) {
        const curLevels = getLevels()
        const lastL = curLevels[index - 1]
        const nextL = curLevels[index + 1]
        item[iptTypeObj[type]] = -1
        findErrorRun(item, lastL, nextL, type)
    }

    function findErrorRun(item, lastL, nextL, type) {
        const zeroFlag = findZeroError(item, type)
        if (zeroFlag) {
            return
        }
        findNextError(item, nextL, type)
        findLastError(item, lastL, type)
    }

    function findZeroError(l, type) {
        if (zeroReg.test(l[type] as string)) {
            l[iptTypeObj[type]] = 0
            return true
        } else {
            return false
        }
    }

    function findLastError(l, lastL, type) {
        if (lastL == null) {
            return
        }
        if (l[type] === '' || lastL[type] === '') {
            if (lastL[iptTypeObj[type]] === 2) {
                lastL[iptTypeObj[type]] = -1
            }
            return
        }
        const bool = oIsGTObj[type] ? (+l[type] <= +lastL[type]) : (+l[type] >= +lastL[type])
        if (bool) {
            l[iptTypeObj[type]] = 1
        } else {
            if (lastL[iptTypeObj[type]] === 2) {
                lastL[iptTypeObj[type]] = -1
            }
        }
    }

    function findNextError(l, nextL, type) {
        if (nextL == null) {
            return
        }
        if (l[type] === '' || nextL[type] === '') {
            if (nextL[iptTypeObj[type]] === 1) {
                nextL[iptTypeObj[type]] = -1
            }
            return
        }
        const bool = oIsGTObj[type] ? (+l[type] >= +nextL[type]) : (+l[type] <= +nextL[type])
        if (bool) {
            l[iptTypeObj[type]] = 2
        } else {
            if (nextL[iptTypeObj[type]] === 1) {
                nextL[iptTypeObj[type]] = -1
            }
        }
    }

    return {
        isIpt,
        delConfirm,
        handleIpt
    }
}

// 阿拉伯数字转中文数字
// 只支持整数
export function NoToChinese(num) {
    const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    const unit = ["", "十", "百", "千", "万"]
    num = parseInt(num)
    const getWan = (temp) => {
        const strArr = temp.toString().split("").reverse()
        let newNum = ""
        for (let i = 0; i < strArr.length; i++) {
            newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
        }
        return newNum
    }
    const overWan = Math.floor(num / 10000)
    let noWan: string | number = num % 10000
    if (noWan.toString().length < 4) { noWan = "0" + noWan }
    const result = overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num)
    return result.startsWith('一十') ? result.slice(1) : result
}

export function createCmpEngine(cmp: any) {
    return function (options: {
        isReturnInstance?: boolean
        props?: any
        callback?: () => any
    } = {}) {
        const Comp = Vue.extend(cmp)
        const instance = new Comp() as any
        if (options.props instanceof Object) {
            Object.keys(options.props).forEach(k => instance.$props[k] = options.props[k])
        }
        instance.$mount()
        document.body.appendChild(instance.$el)
        typeof instance.open === 'function' && instance.open()
        instance.$on('close', close)

        function close() {
            if (document.body.contains(instance.$el)) {
                document.body.removeChild(instance.$el)
                instance.$destroy()
                options.callback && options.callback()
            }
        }
    
        return options.isReturnInstance ? instance : close
    }
}

export function createVideoImg (videoEl: CanvasImageSource, width: number = 300, height: number = 300) {
    const canv = document.createElement('canvas')
    const ctx = canv.getContext("2d")!
    canv.width = width
    canv.height = height
    ctx.drawImage(videoEl, 0, 0, canv.width, canv.height)
    return canv.toDataURL("image/png")
}

export interface IPayment {
    payment_type: number
    payment_type_text: string
    payment_time: string
    payment_amount: number
    change: number
    payment_status: number
    custom_payment: {
        name: string
    }
}

export function getPaymentsText(payments: IPayment[], join: string = ' | ', withMoney: boolean = false) {
    return payments.map((payment: IPayment) => {
        // 自定义支付方式的类型为12
        if (withMoney) {
            return `${payment.payment_type === 12 ? payment.custom_payment.name : payment.payment_type_text}: ${payment.payment_amount}`
        }
        return payment.payment_type === 12 ? payment.custom_payment.name : payment.payment_type_text
    }).join(join)
}


export function judgeClient() {
    const u = navigator.userAgent
    // tslint:disable-next-line:no-shadowed-variable
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1   // 判断是否是 android终端
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)    // 判断是否是 iOS终端
    if (isAndroid) {
      return 'Android'
    } else if (isIOS) {
      return 'IOS'
    } else {
      return 'PC'
    }
}

export function isWX(): boolean {
    const ua = navigator.userAgent.toLowerCase()

    // tslint:disable-next-line:triple-equals
    return ua.match(/MicroMessenger/i) as any == "micromessenger"
}
